import { model as authorizePaymentModel } from '$/authorize-payment'
import { model as creditCardModel } from '$/credit-card'
import { model as paymentInfoModel } from '$/payment-info'
import { sample } from 'effector'
import { reset } from 'patronum'
import { model as paymentGenericModel } from '~/features/payment/generic'

// Handle authorize errors
sample({
  clock: authorizePaymentModel.$commonAuthorizeError,
  target: paymentGenericModel.$paymentError,
})

reset({
  clock: paymentGenericModel.resetErrors,
  target: authorizePaymentModel.$authorizeErrors,
})

// reset current payment step and payment info on close
reset({
  clock: paymentGenericModel.closePaymentPopup,
  target: [
    paymentInfoModel.$uiPaymentInfo,
    creditCardModel.$creditCardNumber,
    creditCardModel.$creditCardMonth,
    creditCardModel.$creditCardYear,
    creditCardModel.$creditCardCvv,
  ],
})

reset({
  clock: [paymentGenericModel.goBackToPreviousStep],
  target: [
    creditCardModel.$creditCardNumber,
    creditCardModel.$creditCardMonth,
    creditCardModel.$creditCardYear,
    creditCardModel.$creditCardCvv,
  ],
})
